import React from "react";
import Button from "../Button";

export type CookieSettingsProps = {
    heading: string;
    buttonLabel: string;
};

const CookieSettingsWidget = (props: CookieSettingsProps) => {
    return (
        <>
            <div className="cky-audit-table-element"></div>
            <h2>{props.heading}</h2>
            <Button id="cookiePolicyButton" theme="secondary" className="cky-banner-element">
                {props.buttonLabel}
            </Button>
        </>
    );
};

export default CookieSettingsWidget;
